
export default {
  name: 'BlankLayout',
}
